var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ak-default"},[_c('header',[_c('myNav')],1),_c('section',[_c('article',[_c('myNaver'),_c('div',{staticStyle:{"padding":"20px 30px","box-sizing":"border-box","flex":"1","min-width":"0","height":"100%","overflow-y":"auto"}},[_c('router-view'),_c('div',{staticStyle:{"height":"10px"}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }